export const convertPrice = (price: number) => {
  const formattedNumber = price.toLocaleString();
  return '$' + formattedNumber;
};
